/**
 * Brand theming for react-select (STC_003, STC_006).
 *
 * react-select ships its own theme object and does NOT read the Chakra theme, so
 * every dropdown in the app rendered its highlighted/selected option in the
 * library's default Atlassian blue:
 *
 *   primary   #2684FF  selected option background, focused control border
 *   primary75 #4C9AFF
 *   primary50 #B2D4FF  option :active
 *   primary25 #DEEBFF  focused/hovered option background
 *
 * 23 files import react-select directly and there is no shared wrapper, so
 * passing `theme` at each call site would mean 23 edits and would still leave
 * the next new dropdown blue. `defaultTheme` is a documented export and is the
 * object every instance falls back to, so retinting it once here fixes them all
 * — including the ones that pass their own `styles`, since those only override
 * the properties they name and inherit these colours for the rest.
 *
 * Imported for its side effect from src/index.js, before <App> mounts.
 *
 * Colours come from theme/brand.js, i.e. REACT_APP_PRIMARY_COLOR. Nothing here
 * is hardcoded — PRIMARY_SCALE is the 50-900 ramp derived from that one value.
 */
import { defaultTheme } from 'react-select';
import { PRIMARY_BG, PRIMARY_SCALE } from './brand';

// Mutate in place rather than reassigning: `defaultTheme` is a live binding that
// react-select closes over internally, so replacing the object would not be seen.
Object.assign(defaultTheme.colors, {
  primary: PRIMARY_BG,
  // Progressively lighter tints, mirroring the spacing of the defaults above.
  primary75: PRIMARY_SCALE[400],
  primary50: PRIMARY_SCALE[300],
  primary25: PRIMARY_SCALE[100],
});

export default defaultTheme;
